<template>
  <div class="popup_wrap" style="width:1050px; height: 700px;">
    <button class="layer_close" v-show="!popupComponent" @click.prevent="$emit('close')">close</button>
    <div class="popup_cont">
      <!-- popup_cont -->
      <h1 class="page_title">{{ $t('msg.ONEX020P061.001') }}</h1> <!-- Booking Cancel Fee 정산 -->
      <div class="content_box">
        <!-- content_box -->
        <table class="tbl_col">
          <colgroup>
            <col width="6%">
            <col width="10%">
            <col width="10%">
            <col width="5%">
            <col width="5%">
            <col width="10%" v-if="viewModeYn === 'N'">
            <col width="10%" v-if="viewModeYn === 'N'">
            <col width="10%" v-if="viewModeYn === 'N'">
            <col width="10%" v-if="viewModeYn === 'Y'">
            <col width="10%" v-if="viewModeYn === 'Y'">
            <col width="10%" v-if="viewModeYn === 'Y'">
            <col width="5%">
            <col width="11%">
            <col width="11%">
            <col width="11%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.ONEX020P061.002') }}</th> <!-- Kind -->
              <th>{{ $t('msg.ONEX020P061.003') }}</th> <!-- Booking No. -->
              <th>{{ $t('msg.ONEX020P061.004') }}</th> <!-- CNTR No. -->
              <th>{{ $t('msg.ONEX020P061.005') }}</th> <!-- Size -->
              <th>{{ $t('msg.ONEX020P061.006') }}</th> <!-- Type -->
              <th>Starting Date</th> <!-- 픽업일 -->
              <th>타 부킹에 사용</th> <!-- 타 부킹에 사용 -->
              <th>Expiry Date</th> <!-- 반납예정일 -->
              <th>{{ $t('msg.ONEX020P061.009') }}</th> <!-- Over Day -->
              <th>AMT</th> <!-- DET AMT -->
              <th>{{ $t('msg.ONEX020P061.011') }}</th> <!-- VAT -->
              <th>{{ $t('msg.ONEX020P061.012') }}</th> <!-- G.TTL -->
            </tr>
          </thead>
          <tbody v-if="viewModeYn === 'N'">
            <tr v-for="(container, index) in containerList" :key="index">
              <td v-if="container.cntrStsCd === 'GTO'">{{ $t('msg.ONEX020P061.013') }}</td>
              <td v-else-if="container.cntrStsCd === 'GTI'">DEM</td>
              <td>{{ parentInfo.bkgNo }}</td>
              <td>{{ container.cntrNo }}</td>
              <td>{{ container.cntrSzCd }}</td>
              <td>{{ container.cntrTypCd }}</td>
              <td>{{ container.pcupReqDt }}</td>
              <td v-if="container.cntrRk === '1'">
                <input type="checkbox" :id="'otherBookingYn_' + index" v-model="container.otherBookingYn" true-value="Y" false-value="N">
                <label :for="'otherBookingYn_' + index"></label>
              </td>
              <td v-else-if="container.cntrRk !== '1'">
                <input type="checkbox" :id="'otherBookingYn_' + index" v-model="container.otherBookingYn" true-value="Y" false-value="N">
                <label :for="'otherBookingYn_' + index"></label>
              </td>
              <template v-if="memberDetail.userCtrCd === 'KR'">
                <td v-if="container.cntrRk === '1'">
                  <e-date-picker :disabled="container.otherBookingYn === 'Y'" @input="onInput(index, container.cntrStsCd)" :id="'returnDate_' + index" :value="''" />
                </td>
                <td v-else-if="container.cntrRk !== '1'">
                  <e-date-picker @input="onInput(index, container.cntrStsCd)" :id="'returnDate_' + index" :value="container.oldMvntDt" disabled />
                </td>
              </template>
              <template v-else>
                <td v-if="container.cntrRk === '1'">
                  <e-date-picker :disabled="container.otherBookingYn === 'Y'" @input="onInput(index, container.cntrStsCd)" :id="'returnDate_' + index" :value="$ekmtcCommon.isEmpty(container.oldMvntDt)? container.toDay : container.oldMvntDt" />
                </td>
                <td v-else-if="container.cntrRk !== '1'">
                  <e-date-picker @input="onInput(index, container.cntrStsCd)" :id="'returnDate_' + index" :value="container.oldMvntDt" disabled />
                </td>
              </template>

              <td>{{ $ekmtcCommon.changeNumberFormat(container.overDay, { isComma: true }) }}<template v-if="container.overDay">{{ $t('msg.ONEX020P061.014') }}</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat(container.det, { isComma: true }) }} <template v-if="container.det">({{ container.curCd }})</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat((container.det * 0.1), { isComma: true }) }} <template v-if="container.det">({{ container.curCd }})</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat((container.det + (container.det * 0.1)), { isComma: true }) }} <template v-if="container.det">({{ container.curCd }})</template></td>
            </tr>
          </tbody>
          <tbody v-if="viewModeYn === 'Y'">
            <tr v-for="(vo, index) in nonFreightList" :key="index">
              <td>Cancel</td>
              <td>{{ vo.bkgNo }}</td>
              <td>{{ vo.cntrNo }}</td>
              <td>{{ vo.cntrSzCd }}</td>
              <td>{{ vo.cntrTypCd }}</td>
              <td>{{ getNewDateFormat(vo.gateStrDt) }}</td>
              <td>
                <input type="checkbox" :id="'otherBookingYn_' + index" v-model="vo.otherBookingYn" true-value="Y" false-value="N" disabled>
                <label :for="'otherBookingYn_' + index"></label>
              </td>
              <template v-if="memberDetail.userCtrCd === 'KR'">
                <td>
                  <template v-if="vo.ovrDds === 0">
                    -
                  </template>
                  <template v-else>
                    {{ $ekmtcCommon.isEmpty(vo.gateEndDt) ? '- ' : getNewDateFormat(vo.gateEndDt) }}
                  </template>
                </td>
              </template>
              <template v-else>
                <td>{{ $ekmtcCommon.isEmpty(vo.gateEndDt) ? '- ' : getNewDateFormat(vo.gateEndDt) }}</td>
              </template>
              <td>{{ $ekmtcCommon.changeNumberFormat(vo.ovrDds, { isComma: true }) }}<template v-if="vo.ovrDds">{{ $t('msg.ONEX020P061.014') }}</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat(vo.locAmt, { isComma: true }) }} <template v-if="vo.locAmt">({{ vo.curCd }})</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat(vo.invTaxAmt, { isComma: true }) }} <template v-if="vo.invTaxAmt">({{ vo.curCd }})</template></td>
              <td>{{ $ekmtcCommon.changeNumberFormat((vo.locAmt + vo.invTaxAmt), { isComma: true }) }} <template v-if="vo.det">({{ vo.curCd }})</template></td>
            </tr>
          </tbody>
        </table>
        <p class="txt_desc">
          <!-- <span class="font_medium">{{ $t('msg.SETT010T010.091') }}</span> <br> -->
          <span>
            {{ $t('msg.ONEX020P061.039') }}
          </span>
        </p>
      </div>
      <div class="mt10 text_center">
        <!-- <a v-show="viewModeYn === 'Y'" class="button blue lg" @click.prevent="fnInvoicePop('')">{{ $t('msg.ONEX020P061.015') }}</a> Invoice 발행/출력 -->
        <a :class="viewModeYn === 'Y' ? 'button gray lg disabled' : 'button blue lg'" @click.prevent="fnIssue()">{{ $t('msg.CMBA630.011') }}</a> <!-- Invoice 발행/출력 -> 신청 -->
        <a :class="viewModeYn === 'Y' ? 'button blue lg' : 'button gray lg disabled'" @click.prevent="fnFreightPop()">{{ $t('msg.SETT060G010.013') }}</a> <!-- 운임수납 -> 입금/세금 계산서 입력 -->
        <!-- <a class="button gray lg" @click.prevent="$emit('close')">{{ $t('msg.ONEX020P061.017') }}</a> 닫기 -->
      </div>
    </div>
    <win-layer-pop class="booking-cancel-fee-pop">
      <component
        v-if="popupComponent"
        :is="popupComponent"
        @close="closePopup"
        :parent-info="popupParams"
        :freight-bill-info="freightBillInfo"
      />
    </win-layer-pop>
  </div>
</template>

<script>

import { rootComputed } from '@/store/helpers'
import demDetTariff from '@/api/rest/trans/demDetTariff'
import EDatePicker from '@/components/common/EDatePicker'
import bookings from '@/api/rest/trans/bookings'
import nonFreight from '@/api/rest/settle/nonFreight'
import InputTaxInvoiceInfo from '@/pages/settle/popup/InputTaxInvoiceInfo'

export default {
  name: 'BookingCancelFeePop',
  components: {
    EDatePicker,
    InputTaxInvoiceInfo,
    DemInvoicePop: () => import('@/pages/settle/popup/DemInvoicePop'),
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          bkgNo: '',
          ctrCd: '',
          eiCatCd: 'O'
        }
      }
    }
  },
  data () {
    return {
      bkgNo: '',
      containerList: [],
      nonFreightList: [],
      viewModeYn: 'N',
      formData: {
        ctrCd: '',
        demDetCatCd: '',
        portCd: '',
        eiCatCd: 'O'
      },
      popupComponent: null,
      popupParams: {},
      freightBillInfo: {},
      otherBookingYn: 'N'
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    this.bkgNo = this.parentInfo.bkgNo
    this.init()
  },
  methods: {
    async init () {
      await this.getNonFreightBooking()
      if (this.viewModeYn === 'N') {
        await this.getContainerLog()
      }
      // await Promise.all([
      //   this.getContainerLog(),
      //   this.getNonFreightBooking()
      // ])
    },
    async getContainerLog () {
      const result = await bookings.getContainerLog({ bkgNo: this.bkgNo, cntrStsCd: 'GTO' })

      console.log('getContainerLog @@@@@ ', result)

      if (result.data.length > 0) {
        this.containerList = result.data.map((container) => {
          container.pcupReqDt = this.getNewDateFormat(container.mvntDt)
          container.otherBookingYn = 'N'

          if (container.cntrRk === '1' && this.$ekmtcCommon.isEmpty(container.oldMvntDt)) {
            let pcupReqDt = new Date(this.getNewDateFormat(container.mvntDt)).setHours(0, 0, 0, 0)
            let toDay = new Date(this.getNewDateFormat(container.toDay)).setHours(0, 0, 0, 0)
            let difference = toDay - pcupReqDt
            container.overDay = difference < 0 ? 0 : (difference / (1000 * 3600 * 24))
          } else {
            //container.overDay = (container.oldMvntDt - container.mvntDt) < 0 ? -1 : (container.oldMvntDt - container.mvntDt) === 0 ? 0 : ((container.oldMvntDt - container.mvntDt))
            const startDate = new Date(this.getNewDateFormat(container.mvntDt)).setHours(0, 0, 0, 0)
            const endDate = new Date(this.getNewDateFormat(container.oldMvntDt)).setHours(0, 0, 0, 0)
            const difference = endDate - startDate

            container.overDay = difference < 0 ? -1 : (difference / (1000 * 3600 * 24))
          }
          if (container.overDay > -1) {
            container.det = 0
            container.vat = 0
            container.curCd = ''
            container.overDay = container.overDay + 1
            this.calculateFor(container, (container.cntrStsCd === 'GTO') ? '02' : '01').then(total => {
              container.det = total
              container.vat = 0.1
              container.curCd = 'KRW'
            })
          } else {
            container.det = 0
            container.vat = 0
            container.curCd = ''
          }
          return container
        })
      }
    },
    async getNonFreightBooking () {
      await nonFreight.getNonFreightBooking({ bkgNo: this.bkgNo }).then(async result => {
        if (result.data.length > 0) {
          this.nonFreightList = result.data
          this.viewModeYn = 'Y'
        } else {
          this.nonFreightList = []
          this.viewModeYn = 'N'
        }
      })
    },
    async fnFreightPop () {
      let bookingInfo = this.nonFreightList.length > 0 ? this.nonFreightList[0] : null

      if (bookingInfo !== null) {
        //let cntrList = [{ cntrNo: bookingInfo.cntrNo }]
        let cntrList = []
        for (let f of this.nonFreightList) {
            if (f.ovrDds > 0) {
              cntrList.push(
                {
                  cntrNo: f.cntrNo,
                  extsDt: f.gateStrDt,
                  freeDds: f.freeDds,
                  ovrDds: f.ovrDds,
                  totAmt: parseInt(f.locAmt) + parseInt(f.invTaxAmt),
                  locAmt: f.locAmt,
                  dcAmt: 0,
                  cfmYn: 'N',
                  dcRt: 0,
                  cntrSzCd: f.cntrSzCd,
                  cntrTypCd: f.cntrTypCd,
                  demDetCatCd: f.demDetCatCd
                }
              )
            }

          // let obj = {
          //   cntrNo: f.cntrNo,
          //   extsDt: '',
          //   freeDds: 0,
          //   ovrDds: f.ovrDds,
          //   totAmt: parseInt(f.locAmt) + parseInt(f.invTaxAmt),
          //   dcAmt: 0,
          //   cfmYn: 'N',
          //   dcRt: 0,
          //   cntrSzCd: f.cntrSzCd,
          //   cntrTypCd: f.cntrTypCd
          // }
        }
        let info = {
          dpId: '',
          dpType: 'B',
          isShow: {
            info: false,
            method: true,
            tax: true
          },
          blList: [{
            blNo: bookingInfo.blNo,
            krw: parseInt(bookingInfo.locAmt) + parseInt(bookingInfo.invTaxAmt),
            usd: 0,
            exRate: 1136, //TODO
            currency: 'KRW',
            obrdDt: '', //TODO
            demDetCatCd: '07', // 07 CANCEL
            eiCatCd: 'O', //bookingInfo.eiCatCd,
            cntrList: cntrList//this.nonFreightList//cntrList
          }],
          bookingInfo: bookingInfo,
          btnType: 'BOOKINGCANCEL'
        }
        this.freightBillInfo = info
        this.popupComponent = 'InputTaxInvoiceInfo'
        this.$ekmtcCommon.layerOpen('.booking-cancel-fee-pop')
      }
    },
    //반납예정일 변경시
    onInput (index, flag) {
      if (this.validationCheck(index, flag)) {
        this.calculate(index, (flag === 'GTO') ? '02' : '01')
      }
    },
    //벨리데이션
    validationCheck (index) {
      let isOk = true

      const selector = document.querySelector('#returnDate_' + index)
      const selectorYn = document.querySelector('#otherBookingYn_' + index)

      this.$ekmtcCommon.hideErrorTooltip(selector)

      if (selector && selector.value === '' && selectorYn.value === 'N') {
        this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147')) // 필수 입력 항목입니다.
        isOk = false
        return isOk
      }
      if (selector) {
      const pickUpDate = new Date(this.containerList[index].pcupReqDt).setHours(0, 0, 0, 0) //픽업일
      const returnDate = new Date(selector.value).setHours(0, 0, 0, 0) //반납예정일
      const toDay = new Date(this.getNewDateFormat(this.containerList[index].toDay)).setHours(0, 0, 0, 0)//오늘날짜
      const cntrRk = this.containerList[index].cntrRk
      if (pickUpDate > returnDate) {
        this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.NEWB010P110.018')) //반납예정일은 픽업일보다 빠를 수 없습니다.
        isOk = false
      }

      if (cntrRk === '1' && returnDate < toDay) {
        //this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL270.030')) //반납예정일은 픽업일보다 빠를 수 없습니다.
        //isOk = false
      }
      }
      return isOk
    },
    //계산로직
    async calculate (index, flag) {
      //1.파라미터셋팅
      const targetContainer = this.containerList[index]
      this.formData.ctrCd = 'KR'
      this.formData.portCd = 'PUS'
      //2.DET 계산 테이블 데이터 로딩
      this.formData.demDetCatCd = '02'
      if (flag && flag === '01') {
        this.formData.demDetCatCd = '01'
      }
      const result = await demDetTariff.getDemDetTariffInfoList(this.formData)

      //3.계산 타겟 테이블로 계산 테이블 데이터 필터링
      const detDataList = result.data.demDetCalculatorList

      //4.오버데이 셋팅
      const selector = document.querySelector('#returnDate_' + index)
      let returnDate = new Date(selector.value).setHours(0, 0, 0, 0) //반납예정일
      let pickUpDate = new Date(this.containerList[index].pcupReqDt).setHours(0, 0, 0, 0) //픽업일
      let difference = returnDate - pickUpDate

      targetContainer.overDay = (returnDate - pickUpDate) < 0 ? 0 : (difference / (1000 * 3600 * 24)) + 1
      //difference = returnDate - targetDate //DET일자 계산(반입예정일 - 픽업예정일)
      //calculatedDay = (difference / (1000 * 3600 * 24)) + 1
      //difference = returnDate - targetDate //DET일자 계산(반입예정일 - 픽업예정일)
      //calculatedDay = (difference / (1000 * 3600 * 24)) + 1

      if (targetContainer.overDay === 0) {
        targetContainer.overDay = 0
        targetContainer.det = 0
        targetContainer.vat = 0
        targetContainer.curCd = ''
        this.$set(this.containerList, index, targetContainer)

        return
      }

      //5.타겟컨테이너와 필터링된 계산 테이블로 계산 시작
      const filteredData = detDataList.filter((item) => {
        if (targetContainer.cgoTypCd) {
          return item.cntrTypeCd === targetContainer.cntrTypCd && (item.cgoTypCd === targetContainer.cgoTypCd)
        } else {
          return item.cntrTypCd === targetContainer.cntrTypCd && !item.cgoTypCd
        }
      })[0]

      if (!filteredData) {
         this.$ekmtcCommon.asyncAlertMessage({ message: '계산을 위한 참고데이터가 없습니다.' })
         return
      }

      filteredData.size = targetContainer.cntrSzCd
      filteredData.overDay = targetContainer.overDay

      let total = 0
      //RATE1 계산
      // console.log('rate1')
      const rate1 = this.calculateOverRate(filteredData, 1)
      total += rate1.total
      if (rate1.overFlag === false) {
        //RATE2 계산
        // console.log('rate2')
        const rate2 = this.calculateOverRate(filteredData, 2)
        total += rate2.total
        if (rate2.overFlag === false) {
          //RATE3 계산
          // console.log('rate3')
          const rate3 = this.calculateOverRate(filteredData, 3)
          total += rate3.total
          if (rate3.overFlag === false) {
            //RATE4 계산
            // console.log('rate4')
            const rate4 = this.calculateOverRate(filteredData, 4)
            total += rate4.total
          }
        }
      }

      //6.set
      targetContainer.det = total
      targetContainer.curCd = filteredData.curCd
      this.$set(this.containerList, index, targetContainer)
    },
     async calculateFor (container, flag) {
      //1.파라미터셋팅
      const targetContainer = container
      this.formData.ctrCd = 'KR'
      this.formData.portCd = 'PUS'
      //2.DET 계산 테이블 데이터 로딩
      this.formData.demDetCatCd = '02'
      if (flag && flag === '01') {
        this.formData.demDetCatCd = '01'
      }
      const result = await demDetTariff.getDemDetTariffInfoList(this.formData)

      //3.계산 타겟 테이블로 계산 테이블 데이터 필터링
      const detDataList = result.data.demDetCalculatorList
      //5.타겟컨테이너와 필터링된 계산 테이블로 계산 시작
      const filteredData = detDataList.filter((item) => {
        if (targetContainer.cgoTypCd) {
          return item.cntrTypeCd === targetContainer.cntrTypCd && (item.cgoTypCd === targetContainer.cgoTypCd)
        } else {
          return item.cntrTypCd === targetContainer.cntrTypCd && !item.cgoTypCd
        }
      })[0]
      filteredData.size = targetContainer.cntrSzCd
      filteredData.overDay = targetContainer.overDay

      let total = 0
      //RATE1 계산
      // console.log('rate1')
      const rate1 = this.calculateOverRate(filteredData, 1)
      total += rate1.total
      if (rate1.overFlag === false) {
        //RATE2 계산
        // console.log('rate2')
        const rate2 = this.calculateOverRate(filteredData, 2)
        total += rate2.total
        if (rate2.overFlag === false) {
          //RATE3 계산
          // console.log('rate3')
          const rate3 = this.calculateOverRate(filteredData, 3)
          if (rate3.overFlag === false) {
            //RATE4 계산
            // console.log('rate4')
            const rate4 = this.calculateOverRate(filteredData, 4)
            total += rate4.total
          }
        }
      }
      return total
    },
    //오버레이트 계산
    calculateOverRate (filteredData, stage) {
      let overFlag = false
      //UNTIL 일수 계산
      let until = 0
      let untilRate = 0
      let size = parseInt(filteredData.size)

      if (stage === 1) {
        until = parseInt(filteredData.trf1Dds)
        if (size === 20) {
          untilRate = parseInt(filteredData.trf1Rate20)
        } else if (size === 40) {
          untilRate = parseInt(filteredData.trf1Rate40)
        } else {
          untilRate = parseInt(filteredData.trf1Rate45)
        }
      } else if (stage === 2) {
        until = parseInt(filteredData.trf2Dds)
        if (size === 20) {
          untilRate = parseInt(filteredData.trf2Rate20)
        } else if (size === 40) {
          untilRate = parseInt(filteredData.trf2Rate40)
        } else {
          untilRate = parseInt(filteredData.trf2Rate45)
        }
      } else if (stage === 3) {
        until = parseInt(filteredData.trf3Dds)
        if (size === 20) {
          untilRate = parseInt(filteredData.trf3Rate20)
        } else if (size === 40) {
          untilRate = parseInt(filteredData.trf3Rate40)
        } else {
          untilRate = parseInt(filteredData.trf3Rate45)
        }
      } else {
        until = parseInt(filteredData.trf4Dds)
        if (size === 20) {
          untilRate = parseInt(filteredData.trf4Rate20)
        } else if (size === 40) {
          untilRate = parseInt(filteredData.trf4Rate40)
        } else {
          untilRate = parseInt(filteredData.trf4Rate45)
        }
      }

      let start = 0
      if (stage === 1) {
        start = 1
      } else if (stage === 2) {
        start = 1 + parseInt(filteredData.trf1Dds)
      } else if (stage === 3) {
        start = 1 + parseInt(filteredData.trf2Dds)
      } else if (stage === 4) {
        start = 1 + parseInt(filteredData.trf3Dds)
      }

      until = until === 0 ? 9999 : until

      let total = 0
      for (let i = start; i <= until; i++) {
        total += untilRate

        if (i === filteredData.overDay) {
          overFlag = true
          break
        }
      }

      return { total: total, overFlag: overFlag }
    },
    getNewDateFormat (beforeDate) {
      let year = beforeDate.substring(0, 4)
      let month = beforeDate.substring(4, 6)
      let day = beforeDate.substring(6, 8)
      return year + '-' + month + '-' + day
    },
    async fnIssue () {
      let checkCnt = 0
      let otherBookingYnCnt = 0
      let returnDateCnt = 0
      let allOtherBooking = false
      let allReturnDate = false
      let cancelEmailKind = ''

      // 같은 cntrNo에 dem,det 중 타부킹 신청 1개이상 체크
      // Map 형태 예시: { 'CNTR1': { count: 2, hasY: true }, 'CNTR2': { count: 2, hasY: false } }
      const statusMap = {}

      this.containerList.forEach((vo, idx) => {
        // let otherBookingYn = document.querySelector('#otherBookingYn_' + idx).value
        let returnDate = document.querySelector('#returnDate_' + idx).value

        if (!this.$ekmtcCommon.isEmpty(returnDate) && vo.otherBookingYn === 'N') {
          returnDateCnt += 1
        }

        if (vo.otherBookingYn === 'Y') {
          otherBookingYnCnt += 1
        }

        if (vo.otherBookingYn === 'N' && this.$ekmtcCommon.isEmpty(returnDate)) {
          checkCnt += 1
        }

        // 같은 cntrNo에 dem,det 중 타부킹 신청 1개이상 체크
        // 1단계: 각 번호별로 '상태 정보' 파악 (개수, Y 존재 여부)
        const no = vo.cntrNo
        // 빈 값은 건너뜀
        if (!no || no.trim() === '') return

        if (!statusMap[no]) {
          statusMap[no] = { count: 0, hasY: false }
        }

        statusMap[no].count += 1

        // 현재 아이템이 'Y'라면 해당 그룹은 Y를 가지고 있다고 표시
        if (vo.otherBookingYn === 'Y') {
          statusMap[no].hasY = true
        }
      })

      // 모든 컨테이너에 대해서 타부킹 체크 or 반납예정일 설정해야만 다음 단계 이동 가능
      if (checkCnt > 0) {
          this.$ekmtcCommon.alert({
            alertType: 'simple',
            customCloseBtnText: this.$t('msg.NEWB010150.023'), // 확인
            message: this.$t('msg.ONEX020P061.018') // 모든 컨테이너에 대해서 설정된 후 진행 가능합니다.
          })
          return
      }

      // 2단계: 조건에 맞는 항목만 업데이트
      let updatedCount = 0

      this.containerList.forEach(item => {
        const no = item.cntrNo
        if (!no || !statusMap[no]) return

        const info = statusMap[no]

        // 업데이트 조건 3가지 (AND 조건)
        // 1. 중복된 데이터인가? (count > 1)
        // 2. 그 그룹에 'Y'가 하나라도 존재하는가? (hasY === true) -> 이 조건 덕분에 '둘 다 N'인 경우 제외됨
        // 3. 현재 내 값이 'N'인가?
        if (info.count > 1 && info.hasY && item.otherBookingYn === 'N') {
          item.otherBookingYn = 'Y'
          otherBookingYnCnt++
        }
      })

      // 전부 타부킹 체크
      if (otherBookingYnCnt === this.containerList.length) {
        cancelEmailKind = 'AOB'
        allOtherBooking = true

        if (await this.$ekmtcCommon.asyncAlertMessage({
          message: this.$t('msg.ONEX020P061.019') + '\n\n 1. ' + this.$t('msg.ONEX020P061.020'), //아래 주의사항을 확인 후, 확인 버튼을 눌러 진행해주세요. 타 부킹 사용 요청 시, 귀사의 다른 부킹으로만 픽업컨테이너 사용이 가능합니다 (타포워더 부킹에 사용 불가)',
          useConfirmBtn: true
        })) {
          this.$ekmtcCommon.alert({
            alertType: 'simple',
            customCloseBtnText: this.$t('msg.NEWB010150.023'), // 확인
            message: this.$t('msg.ONEX020P061.021') //타 부킹 사용 요청이 접수되었습니다
          })

          this.sendCancelEmail('AOB')
          await this.insertNonFreight('BSO')

          this.$emit('close', 'booking-cancel-fee-pop')
        } else {
          window.app.$Simplert.close()
        }
      }

      // 전부 반납예정일 체크
      if (returnDateCnt === this.containerList.length) {
        cancelEmailKind = 'ARD'
        allReturnDate = true

        if (await this.$ekmtcCommon.asyncAlertMessage({
          message: this.$t('msg.ONEX020P061.022') + '\n' +
                   this.$t('msg.ONEX020P061.023') + '\n\n' +
                   this.$t('msg.ONEX020P061.024') + '\n\n' +
                   this.$t('msg.ONEX020P061.025') + '\n' +
                   this.$t('msg.ONEX020P061.026') + '\n\n' +
                   this.$t('msg.ONEX020P061.027') + '\n' +
                   this.$t('msg.ONEX020P061.028') + '\n',
          useConfirmBtn: true
        })) {
          await this.sendCancelEmail('ARD')

          if (this.viewModeYn === 'N') {
            await this.insertNonFreight('NF')
          } else {
            await this.fnInvoicePop('')
          }
        } else {
          window.app.$Simplert.close()
        }
      }

      // 타부킹, 반납예정일 mix
      if ((!allOtherBooking && !allReturnDate) && returnDateCnt > 0 && otherBookingYnCnt > 0) {
          cancelEmailKind = 'MRB'

          if (await this.$ekmtcCommon.asyncAlertMessage({
            message: this.$t('msg.ONEX020P061.029') + '\n' +
                    this.$t('msg.ONEX020P061.030') + '\n\n' +
                    this.$t('msg.ONEX020P061.031') + '\n' +
                    this.$t('msg.ONEX020P061.032') + '\n\n' +
                    this.$t('msg.ONEX020P061.033') + '\n' +
                    this.$t('msg.ONEX020P061.034') + '\n\n' +
                    this.$t('msg.ONEX020P061.035') + '\n' +
                    this.$t('msg.ONEX020P061.036') + '\n\n' +
                    this.$t('msg.ONEX020P061.037') + '\n' +
                    this.$t('msg.ONEX020P061.038') + '\n',
            useConfirmBtn: true
          })) {
            await this.sendCancelEmail('ARD')

            if (this.viewModeYn === 'N') {
              await this.insertNonFreight('NF')
            } else {
              await this.fnInvoicePop('')
            }
          } else {
            window.app.$Simplert.close()
          }
      }
    },
    async fnInvoicePop (type) {
      if (type === 'SAVE_END') {
        await this.getNonFreightBooking()
      }

      if (this.viewModeYn === 'N') {
        return
      }

      this.popupParams = {
        invoice: this.nonFreightList[0],
        blNo: this.nonFreightList[0].blNo,
        lang: this.auth.serviceLang,
        usrNm: '',
        ctrCd: this.memberDetail.userCtrCd,
        demDetCatCd: '02',
        eiCatCd: 'O',
        kind: 'BOOKINGCANCELE',
        cntrList: this.nonFreightList
      }
      this.openPopup('DemInvoicePop')
    },
    async insertNonFreight (kind) {
      console.log('insertNonFreight @@@ ', kind)

      let len = this.containerList.length
      let isValid = true

      if (kind === 'BSO') {
        // 전부 타부킹일때, 진행중인엄부 부킹 상태 '취소처리중' 으로 변경
        const param = {
          bkgNo: this.bkgNo,
          bkgCnclKind: kind
        }

        await nonFreight.insertNonFreight(param).then(res => {
          if (res.data === 'S') {
            this.fnInvoicePop('SAVE_END')
          } else {
            this.$ekmtcCommon.alert({
              alertType: 'simple',
              customCloseBtnText: this.$t('msg.NEWB010150.023'), // 확인
              message: '저장에 실패했습니다.'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        for (let i = 0; i < len; i++) {
          if (!this.validationCheck(i)) {
            isValid = false
          }
        }

        if (!isValid) {
          return
        }

        const items = []

        this.containerList.forEach((vo, idx) => {
        if (vo.overDay > 0) {
            items.push({
              // demDetCatCd: '07', // 02: DETENTION, 07: CANCEL
              demDetCatCd: vo.cntrStsCd === 'GTO' ? '02' : vo.cntrStsCd === 'GTI' ? '01' : '07',
              bkgNo: vo.bkgNo,
              eiCatCd: 'O', // 수출: O, 수입: I
              demSeq: (idx + 1),
              cntrNo: vo.cntrNo,
              cntrSzCd: vo.cntrSzCd,
              cntrTypCd: vo.cntrTypCd,
              cntrQty: '1',
              gateStrDt: vo.pcupReqDt.replaceAll('-', ''),
              gateEndDt: document.querySelector('#returnDate_' + idx).value.replaceAll('.', ''),
              freeDds: 0,
              ovrDds: vo.otherBookingYn === 'Y' ? 0 : vo.overDay,
              curCd: vo.curCd,
              totAmt: vo.otherBookingYn === 'Y' ? 0 : vo.det,
              locAmt: vo.otherBookingYn === 'Y' ? 0 : vo.det,
              exrt: 1,
              rmk: '',
              bkgCnclKind: kind
            })
          }
        })

        const params = {
        bkgNo: this.bkgNo,
        invKndCd: '02', // 02: DETENTION
        // bookingCancelCntrList: this.containerList,
        payPlcCd: 'SEL',
        items: items,
        bkgCnclKind: kind,
        bookingCancelCntrList: items
      }

       await nonFreight.insertNonFreight(params).then(res => {
          if (res.headers.respcode === 'C0000') {
            this.fnInvoicePop('SAVE_END')
          } else {
            let msg = this.$t(res.headers.respmsg)
            if (msg === undefined || msg === '') {
              msg = 'Non-Freight 등록 실패'
            }
            this.$ekmtcCommon.alert({
              alertType: 'simple',
              customCloseBtnText: this.$t('msg.NEWB010150.023'), // 확인
              message: msg
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    openPopup (compNm) {
      this.popupComponent = compNm
      this.$ekmtcCommon.layerOpen('.booking-cancel-fee-pop')
    },
    closePopup () {
      this.popupComponent = null
      this.$ekmtcCommon.layerClose('.booking-cancel-fee-pop')
    },
    async sendCancelEmail (kind) {
      console.log('sendCancelEmail @@@@@', kind)

      let len = this.containerList.length
      let isValid = true

      const items = []

      this.containerList.forEach((vo, idx) => {
        items.push({
          demDetCatCd: '07', // 02: DETENTION, 07: CANCEL
          bkgNo: vo.bkgNo,
          eiCatCd: 'O', // 수출: O, 수입: I
          demSeq: (idx + 1),
          cntrNo: vo.cntrNo,
          cntrSzCd: vo.cntrSzCd,
          cntrTypCd: vo.cntrTypCd,
          cntrQty: '1',
          gateStrDt: vo.pcupReqDt.replaceAll('-', ''),
          returnDt: document.querySelector('#returnDate_' + idx).value.replaceAll('.', ''),
          freeDds: 0,
          ovrDds: vo.otherBookingYn === 'Y' ? 0 : vo.overDay,
          curCd: vo.curCd,
          totAmt: vo.otherBookingYn === 'Y' ? 0 : vo.det,
          locAmt: vo.otherBookingYn === 'Y' ? 0 : vo.det,
          exrt: 1,
          rmk: '',
          otherBookingYn: vo.otherBookingYn,
          plcCd: vo.plcCd,
          ctrCd: vo.ctrCd
        })
      })

      // const params = {
      //   bkgNo: this.bkgNo,
      //   // bookingCancelCntrList: this.containerList,
      //   payPlcCd: 'SEL',
      //   cancelEmailKind: kind,
      //   bookingCancelCntrList: items
      // }

      const params = {
        bkgNo: this.bkgNo,
        invKndCd: '02', // 02: DETENTION
        // bookingCancelCntrList: this.containerList,
        payPlcCd: 'SEL',
        items: items,
        cancelEmailKind: kind,
        bookingCancelCntrList: items
      }

      // await nonFreight.insertNonFreight(params).then(res => {
      await bookings.sendBookingCancelFeeMail(params).then(res => {
        console.log('sendBookingCancelFeeMail @@@@@ ', res)

        if (res.headers.respcode !== 'C0000') {
          let msg = this.$t(res.headers.respmsg)
          if (msg === undefined || msg === '') {
            msg = '메일 전송에 실패하였습니다.'
          }
          this.$ekmtcCommon.alert({
            alertType: 'simple',
            customCloseBtnText: this.$t('msg.NEWB010150.023'), // 확인
            message: msg
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>

</style>
